module.exports = __webpack_public_path__ + "img/magic-show.91e32ecb.webp";